import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["approveStep", "rejectStep", "acknowledgement"]

  connect() {
    this.showApproveStep()
    this.boundShowApproveStep = () => this.showApproveStep()
    $(this.element).on("show.bs.modal hidden.bs.modal", this.boundShowApproveStep)
  }

  disconnect() {
    $(this.element).off("show.bs.modal hidden.bs.modal", this.boundShowApproveStep)
  }

  showRejectStep(event) {
    event.preventDefault()

    const form = this.element.closest("form") || this.element.querySelector("form")
    if (form && !form.reportValidity()) return

    this.approveStepTarget.style.display = "none"
    this.rejectStepTarget.style.display = "block"
    this.toggleRequiredFields(this.rejectStepTarget, true)
  }

  showApproveStep() {
    this.approveStepTarget.style.display = "block"
    this.rejectStepTarget.style.display = "none"
    this.toggleRequiredFields(this.rejectStepTarget, false)
  }

  back(event) {
    event.preventDefault()
    if (this.hasAcknowledgementTarget) this.acknowledgementTarget.checked = false
    this.showApproveStep()
  }

  toggleRequiredFields(step, enable) {
    step.querySelectorAll("[data-required]").forEach((field) => {
      if (enable) {
        field.setAttribute("required", "required")
      } else {
        field.removeAttribute("required")
      }
    })
  }
}
